module.exports = __webpack_public_path__ + "img/back05.cc735a09.jpg";